// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SiteUnidades_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/site_unidades/salvar (staff, Full).
 * Localized text travels as {locale: text} maps; `id` absent = create.
 */
import type { Site_UnidadeTrackingRow } from './Site_UnidadeTrackingRow'
import { registerContract } from './validate'

export interface SiteUnidades_SalvarInput {
slug: string
nome: Record<string, string>
id?: number
franquia_id?: number
endereco?: Record<string, string>
whatsapp?: string
whatsapp_sem_tracos?: string
instagram?: string
facebook?: string
tiktok?: string
estado?: string
cidade?: string
pais?: string
status?: string
latitude?: number
longitude?: number
coords_lock?: boolean
imagem_url?: string
imagem_alt?: string
galeria?: undefined[]
horario_semana_abre?: string
horario_semana_fecha?: string
horario_sabado_abre?: string
horario_sabado_fecha?: string
tracking?: Site_UnidadeTrackingRow
}

registerContract('SiteUnidades_SalvarInput', {
  slug:                 { type: 'string',  required: true },
  nome:                 { type: 'object',  required: true },
  id:                   { type: 'number',  required: false },
  franquia_id:          { type: 'number',  required: false },
  endereco:             { type: 'object',  required: false },
  whatsapp:             { type: 'string',  required: false },
  whatsapp_sem_tracos:  { type: 'string',  required: false },
  instagram:            { type: 'string',  required: false },
  facebook:             { type: 'string',  required: false },
  tiktok:               { type: 'string',  required: false },
  estado:               { type: 'string',  required: false },
  cidade:               { type: 'string',  required: false },
  pais:                 { type: 'string',  required: false },
  status:               { type: 'string',  required: false },
  latitude:             { type: 'number',  required: false },
  longitude:            { type: 'number',  required: false },
  coords_lock:          { type: 'boolean', required: false },
  imagem_url:           { type: 'string',  required: false },
  imagem_alt:           { type: 'string',  required: false },
  galeria:              { type: 'array',   required: false },
  horario_semana_abre:  { type: 'string',  required: false },
  horario_semana_fecha: { type: 'string',  required: false },
  horario_sabado_abre:  { type: 'string',  required: false },
  horario_sabado_fecha: { type: 'string',  required: false },
  tracking: {
    type: 'object',
    required: false,
    fields: {
      google_ads_ids: { type: 'array',   required: false },
      meta_pixel:     { type: 'string',  required: false },
      gtm_extra:      { type: 'string',  required: false },
    },
  },
})
